import Application from "../../Application";
import CreateCaseLawDocumentTypeInteractor from "../../caseLawDocuments/interactor/CreateCaseLawDocumentTypeInteractor";
import GetAllCaseLawDocumentTypesInteractor from "../../caseLawDocuments/interactor/GetAllCaseLawDocumentTypesInteractor";
import ShowCaseLawDocumentTypesInteractor from "../../caseLawDocuments/interactor/ShowCaseLawDocumentTypesInteractor";
import CaseLawDocumentTypeListPage from "../../caseLawDocuments/ui/pages/CaseLawDocumentTypeListPage";
import Area, { IArea } from "../../core/areas/Area";
import GetAllRegistryInstitutionsInteractor from "../../organisations/interactors/GetAllRegistryInstitutionsInteractor";
import { IRouter } from "../../runtime/Router";
import CreateGenericCodebookItemInteractor from "../interactor/CreateGenericCodebookItemInteractor";
import GetGenericCodebookInteractor from "../interactor/GetGenericCodebookInteractor";
import ShowGenericCodebookInteractor from "../interactor/ShowGenericCodebookInteractor";
import UpdateGenericCodebookItemInteractor from "../interactor/UpdateGenericCodebookItemInteractor";
import GenericCodebookPage from "../ui/GenericCodebookPage";

export default class GenericCodebookArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;

    container.registerInteractor(
      "getGenericCodebook",
      GetGenericCodebookInteractor
    );
    container.registerInteractor(
      "createGenericCodebookItem",
      CreateGenericCodebookItemInteractor
    );
    container.registerInteractor(
      "updateGenericCodebookItem",
      UpdateGenericCodebookItemInteractor
    );
    container.registerInteractor(
      "showGenericCodebook",
      ShowGenericCodebookInteractor
    );
    container.registerInteractor(
      "getAllRegistryInstitutions",
      GetAllRegistryInstitutionsInteractor
    );
    container.registerInteractor(
      "getAllCaseLawDocumentTypes",
      GetAllCaseLawDocumentTypesInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentTypes",
      ShowCaseLawDocumentTypesInteractor
    );
    container.registerInteractor(
      "createCaseLawDocumentType",
      CreateCaseLawDocumentTypeInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/codebooks/generic/:codebookTypeName",
        page: this.createPage({
          Page: GenericCodebookPage,
          action: this.showGenericCodebookPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/codebooks/case-law-document-types",
        page: this.createPage({
          Page: CaseLawDocumentTypeListPage,
          action: this.showCaseLawDocumentTypesPage.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showGenericCodebookPage(params: any) {
    return this.application.container
      .resolve<ShowGenericCodebookInteractor>("showGenericCodebook")
      .execute(params.codebookTypeName);
  }

  public showCaseLawDocumentTypesPage() {
    return this.application.container
      .resolve<ShowCaseLawDocumentTypesInteractor>("showCaseLawDocumentTypes")
      .execute();
  }
}
